module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-terms"
  }, [_c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "text-center headline-container"
  }, [_c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "headline"
  }, [_vm._v("Terms & conditions")])]), _vm._v(" "), (_vm.terms.length) ? _c('div', {
    staticClass: "container block-text",
    domProps: {
      "innerHTML": _vm._s(_vm.terms)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f52d9b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Terms.vue
// module id = 1508
// module chunks = 0